import { render } from "./MMProjects.vue?vue&type=template&id=fc024b56"
import script from "./MMProjects.vue?vue&type=script&lang=js"
export * from "./MMProjects.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__